import { useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import { withOktaAuth } from '@okta/okta-react';
import { TopBar, TopBarV2 } from 'portal-commons';
import { useAuthContext } from '@/contexts';
import { GERMANY_EVENTS_ENABLED } from '@/constants';
import { ROUTES } from '@/constants/paths';

const Header = ({ authenticated, oktaAuth, title, note, history }) => {
  const { profile } = useAuthContext();

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.setItem('logoutSuccess', true);
    oktaAuth.signOut('/login');
  };

  const userName = localStorage.getItem('okta-token-storage')
    ? JSON.parse(localStorage.getItem('okta-token-storage')).idToken
      ? JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims
          .name
      : localStorage.getItem('userInfo')
      ? JSON.parse(localStorage.getItem('userInfo')).name
      : ''
    : '';

  const menus = useMemo(() => {
    const MenuItem =
      profile?.market === 'DE' || profile?.market === 'HU'
        ? TopBarV2.MenuItem
        : TopBar.MenuItem;
    const items = [
      <MenuItem
        key="profile"
        data-testid="headerMenuItemProfile"
        onClick={() => {
          history.push('/profile');
        }}
      >
        {profile?.market === 'DE' ? 'Profile' : 'MNO Profile'}
      </MenuItem>,
      <MenuItem
        key="logout"
        data-testid="headerMenuItemLogoutButton"
        onClick={handleLogout}
      >
        Logout
      </MenuItem>,
    ];
    if (profile?.market === 'DE') {
      items.unshift([
        <MenuItem
          key="brandList"
          data-testid="headerMenuItemBrands"
          onClick={() => {
            history.push('/');
          }}
        >
          Brands
        </MenuItem>,
        ...(GERMANY_EVENTS_ENABLED
          ? [
              <MenuItem
                key="eventList"
                data-testid="headerMenuItemEvents"
                onClick={() => {
                  history.push('/events');
                }}
              >
                Events
              </MenuItem>,
            ]
          : []),
      ]);
    }
    if (profile?.market === 'HU') {
      items.splice(
        0,
        1,
        <MenuItem
          key="programList"
          data-testid="headerMenuItemPrograms"
          onClick={() => {
            history.push(ROUTES.PROGRAMS);
          }}
        >
          Programs
        </MenuItem>,
        <MenuItem
          key="senderIdList"
          data-testid="headerMenuItemSenderIds"
          onClick={() => {
            history.push(ROUTES.SENDER_IDS);
          }}
        >
          Sender IDs
        </MenuItem>
      );
    }

    return items;
  }, [profile?.market]);

  if (profile?.market === 'DE' || profile?.market === 'HU') {
    return (
      <TopBarV2
        authenticated={authenticated}
        portal="mno"
        menus={menus}
        onLogoClick={() => history.push('/')}
      />
    );
  }

  return (
    <TopBar
      authenticated={authenticated}
      portal="mno"
      username={userName}
      title={title}
      subText={note}
      menus={menus}
    />
  );
};

export default withRouter(withOktaAuth(Header));
